import React, { useEffect, useState } from "react";
import { appServerSideProps } from "../../utils/getAppService";
import { authGetRequest } from "../../utils/authGetRequest";
import logo from "../.../../../assets/images/shotQualityBetsDarkLogo.png";
import Image from "next/image";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useRouter } from "next/router";
import Link from "next/link";
import MainLayout from "../../components/MainLayout/MainLayout";
import PlanCard from "../../components/update-plan/PlanCard";
import { OrangeCheckMark } from "../../components/svg";
import Utils from "../../utils/Utils";

dayjs.extend(advancedFormat);

const PremiumPricing = ({ user }) => {
  const [authToken, setAuthToken] = useState(null);
  const router = useRouter();
  const emailSubject = encodeURIComponent("API Access Request");
  const emailBody = encodeURIComponent("👍 I would like to learn about API access to ShotQuality");
  const [current, setCurrent] = useState(() => {
    if (!user?.has_paid) return "";
    else if (!user?.accounts || user?.accounts.length == 0) return "";
    const account = user?.accounts[0].account_type.account_name.toLowerCase();
    return (
      ["premium week", "premium month", "premium year", "premium day"].find((type) => account?.includes(type)) || ""
    );
  });
  const [loading, setLoading] = useState(false);
  const mailTo = "hello@shotquality.com";
  useEffect(() => {
    if (user) {
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
    }
  }, [user]);

  const handlePlanChange = (plan) => {
    setLoading(true);
    if (!plan.includes(current)) {
      const payload = {
        email: user.email,
        subscriptionType: plan,
      };

      fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/update-premium-subscription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          setLoading(false);
          if (response["status"] == "success") {
            localStorage.removeItem("user");
            router.push(`/confirmation/success/${plan}`);
          } else if (response["error"]) {
            localStorage.removeItem("user");
            router.push({
              pathname: "/confirmation/failure",
              query: { error: error },
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error updating subscription:", error);
          router.push({
            pathname: "/confirmation/failure",
            query: { error: error },
          });
        })
        .finally(() => setLoading(false));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user) {
      authGetRequest(`/api/visited/pricing`, authToken)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => console.error(err));
    }
  }, [user, authToken]);
  return (
    <>
      {loading && (
        <div className="loader-container">
          <img src={`/android-chrome-512x512.png`} alt="loading" />
        </div>
      )}
      <MainLayout showLiveLinkHeader={false}>
        <div className="bg-white">
          <div className="container">
            <div className="pt-2 text-center ">
              <h2 className="mt-5">Choose your plan to unlock Premium Access</h2>
            </div>
            <div className="row mt-5 d-flex update-plan flex-wrap align-items-center gap-2 justify-content-center">
              {/* {current ? (
                current.includes("day") ? (
                  <PlanCard
                    label="1 Day"
                    price="9.99"
                    period="24 hour live betting access"
                    type="day"
                    isCurrent={current === "premium day"}
                    onPlanChange={handlePlanChange}
                    planValue="daily-premium"
                  />
                ) : null
              ) : (
                <Link href="/register/day-pass">
                  <PlanCard
                    label="1 Day"
                    price="9.99"
                    period="24 hour live betting access"
                    type="day"
                    isCurrent={current === "premium day"}
                    planValue="daily-premium"
                    updateModal="true"
                  />
                </Link>
              )}*/}
              {current && !current.includes("day") ? (
                <PlanCard
                  label="7 Days"
                  price="79.99"
                  period="Every Week"
                  type="week"
                  isCurrent={current === "premium week"}
                  onPlanChange={handlePlanChange}
                  planValue="premium-weekly-25"
                />
              ) : (
                <Link href="/register/premium-weekly-25">
                  <PlanCard
                    label="7 Days"
                    price="79.99"
                    period="Every Week"
                    type="week"
                    isCurrent={current === "premium week"}
                    planValue="premium-weekly-25"
                    updateModal="true"
                  />
                </Link>
              )}
              {current && !current.includes("day") ? (
                <PlanCard
                  label="1 Month"
                  price="249.99"
                  period="Every Month"
                  type="month"
                  isCurrent={current === "premium month"}
                  onPlanChange={handlePlanChange}
                  planValue="premium-monthly-25"
                />
              ) : (
                <Link href="/register/premium-monthly-25">
                  <PlanCard
                    label="1 Month"
                    price="249.99"
                    period="Every Month"
                    type="month"
                    isCurrent={current === "premium month"}
                    planValue="premium-monthly-25"
                    updateModal="true"
                  />
                </Link>
              )}

              {current && !current.includes("day") ? (
                <PlanCard
                  label="1 Year"
                  price="1499.99"
                  period="Every Year"
                  type="year"
                  isCurrent={current === "premium year"}
                  onPlanChange={handlePlanChange}
                  planValue="premium-annual-25"
                />
              ) : (
                <Link href="/register/premium-annual-25">
                  <PlanCard
                    label="1 Year"
                    price="1499.99"
                    period="Every Year"
                    type="year"
                    isCurrent={current === "premium year"}
                    planValue="premium-annual-25"
                    updateModal="true"
                  />
                </Link>
              )}
            </div>
          </div>
          <div className="upgrade-to-premium pb-5 mt-5">
            <div className="row" style={{ margin: "0px !important", padding: "0px !important" }}>
              <h3 className="pt-5 col-sm-12 text-center header">UPGRADE TO PREMIUM</h3>
              <div className="mt-4 col-sm-12">
                <h1 className=" col-sm-12 text-center subheader">GET EARLY PICKS AND ALL LIVE GAMES AND ALL </h1>
                <h1 className=" col-sm-12 text-center subheader">HISTORICAL AND PREDICTED SHOTQUALITY </h1>
                <h1 className=" col-sm-12 text-center subheader">SCORES </h1>
              </div>
            </div>
            <div
              className="row upgrade-to-premium d-flex justify-center pb-5 text-white p-4 rounded"
              style={{ margin: "0px !important", padding: "0px !important" }}
            >
              {/* Left Section */}
              <div className="col-md-1"></div>
              <div className="col-sm-12 col-md-8 mt-5">
                <div className="mb-2 premium-block">
                  <Image src={logo.src} width={500} height={50} loading="lazy" alt="Shotquality Brand image" />

                  <p className="my-3">Predicted and historical scores for every league and every game.</p>
                </div>
                <div className="mb-2 premium-block">
                  <div className="d-flex align-items-center justify-content-start mb-1">
                    <div>
                      <OrangeCheckMark />
                    </div>
                    <div className="mx-3">
                      <h5 className="mx-2">Best Bets</h5>
                      <p>Select picks powered by ShotQuality games simulations</p>
                    </div>
                  </div>
                </div>
                <div className="mb-2 premium-block">
                  <div className="d-flex align-items-center justify-content-start mb-1">
                    <div>
                      <OrangeCheckMark />
                    </div>
                    <div className="mx-3">
                      <h5 className="mt-2">Insider Picks and Analysis</h5>
                      <p>Exclusive access to members only content in our Discord</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section */}
              {/** <div
                className=" contact premium-block flex-column text-center col-sm-12 col-md-5"
                style={{ margin: "0px !important", padding: "0px !important" }}
              >
                <div className="mb-4">
                  <h1 className="display-4">$499.98</h1>
                  <h4>Per Month</h4>
                </div>
                <Link
                  href={"mailto:" + mailTo + "?subject=" + emailSubject + "&body=" + emailBody}
                  className="contact-us w-50"
                  style={{ color: "#fff", padding: "10px 15px" }}
                >
                  {" "}
                  CONTACT US
                </Link>
                </div> */}
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default PremiumPricing;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  return { props: { user } };
});
